

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.DNHmbMCR.js","_app/immutable/chunks/disclose-version.jfViFEmK.js","_app/immutable/chunks/index-client.D5Wu0e6C.js","_app/immutable/chunks/legacy.D7Ty_rE8.js","_app/immutable/chunks/render.BI0DsfJx.js","_app/immutable/chunks/events.BvXFbFGG.js","_app/immutable/chunks/lifecycle.D4rC_9iq.js","_app/immutable/chunks/entry.BSIOWPTz.js"];
export const stylesheets = [];
export const fonts = [];
